export const LEAD_APPROVAL_GET_LEADS = 'LEAD_APPROVAL_GET_LEADS';
export const LEAD_APPROVAL_GET_LEADS_SUCCESS = 'LEAD_APPROVAL_GET_LEADS_SUCCESS';
export const LEAD_APPROVAL_GET_LEADS_FAILURE = 'LEAD_APPROVAL_GET_LEADS_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_approval/redux/constants/lead_approval_get_leads.constants.js